module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "never",
      "header": "过期提醒"
    }
  }, [_c('label', {
    staticStyle: {
      "margin-left": "37px",
      "color": "red"
    }
  }, [_vm._v("备注：资质目前默认30天到期时间")]), _vm._v(" "), _c('el-form-item'), _vm._v(" "), _c('el-form-item'), _vm._v(" "), _c('el-form-item'), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "3px"
    },
    attrs: {
      "label": "默认"
    }
  }, [_c('el-radio-group', [_c('el-radio', [_vm._v("30天")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f80bd44", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f80bd44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/zizhi/noticeset.vue
// module id = 2758
// module chunks = 0